
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m52.2 7.9l2.5 2.6 5.3-3.5c2.2-.3 3.2-5-2.8-3.5-1.5.4-3.8 1.5-5 4.4", fill: "#89664c" }),
	React.createElement("path", { d: "m61.1 7c1.8-.7.5-2.8.5-2.8s.4 1.5-2.4 1.9c-4.1.6-5.2 3.6-5.2 3.6l.7.7c0 0 2.4-1.8 6.4-3.4", fill: "#594640" }),
	React.createElement("path", { d: "m53.5 6c8.8 9.3 1.2 23.3-7.6 39.5-.7 1.4-1.5 2.7-2.2 4.1-6.2 11.5-15.3 12.7-20.2 12.4-5.5-.4-11-3-14.7-6.9-3.8-4-6.3-9.8-6.7-15.7-.4-5.2.5-15.1 11.1-22 1.2-.8 2.5-1.6 3.7-2.4 14.9-9.8 27.8-18.3 36.6-9", fill: "#699635" }),
	React.createElement(
		"g",
		{ fill: "#c7e755" },
		React.createElement("path", { d: "m15 19.9c14.5-9.4 29.3-20.4 37-12.2 7.7 8.1-7.5 18.6-16 34.5-8.5 15.8-18.9 18.5-25.8 11.3-6.8-7.3-9.8-24.1 4.8-33.6" }),
		React.createElement("path", { d: "m11.8 51.8c1.6 1.6 3.3 2.5 5.3 2.6 5.5.4 11.6-4.8 16.7-14.2 2.9-5.5 6.6-10.3 9.9-14.6 5.2-6.7 10-13.1 6.9-16.4-5.3-5.6-19 3.4-30 10.7-1.2.8-2.5 1.6-3.7 2.4-9.1 5.9-9.9 14-9.6 18.3.3 4.4 2 8.6 4.5 11.2" })
	),
	React.createElement("path", { d: "m11.8 51.8c1.6 1.6 3.3 2.5 5.3 2.6 5.5.4 11.6-4.8 16.7-14.2 2.9-5.5 6.6-10.3 9.9-14.6 5.2-6.7 10-13.1 6.9-16.4-5.3-5.6-19 3.4-30 10.7-1.2.8-2.5 1.6-3.7 2.4-9.1 5.9-9.9 14-9.6 18.3.3 4.4 2 8.6 4.5 11.2", fill: "#ffce31", opacity: ".33" }),
	React.createElement("path", { d: "m17.2 27c6-6.6 14.8-6 16.6-2 1.8 4-.8 10-4.8 14.4-4.1 4.4-9.6 7.3-13.3 5.5-3.8-1.8-4.5-11.3 1.5-17.9", fill: "#89664c" }),
	React.createElement("path", { d: "m16.5 33.6c2.6-3.8 5.3-4.8 4.8-3.9-.4.9-1.8 3.1-2.6 5.1-.9 2-1.4 3.7-2.4 4.3-1 .8-2.3-1.4.2-5.5", fill: "#d3976e" }),
	React.createElement("path", { d: "m26.4 36.7c-3.5 3.7-7.7 6.6-11.7 7.5.3.3.6.6 1 .7 3.8 1.9 9.2-1 13.3-5.5 4-4.4 6.6-10.4 4.8-14.4-.2-.4-.4-.7-.7-1-.7 4.2-3.3 8.9-6.7 12.7", fill: "#594640" })
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/avocado.js
// module id = 680
// module chunks = 0